import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../../context/CartContext';

const featuredProducts = [
  { id: 1, title: 'Andover Spectacles', desc: 'Unisex style with UV protection', price: '89.99', image: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=800&auto=format' },
  { id: 2, title: 'Baker Frames', desc: 'Classic round design, lightweight', price: '79.99', image: 'https://images.unsplash.com/photo-1591076482161-42ce6da69f67?w=800&auto=format' },
  { id: 3, title: 'Carter Sunglasses', desc: 'Sleek aviator style, polarized lenses', price: '99.99', image: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=800&auto=format' },
  { id: 4, title: 'Davis Readers', desc: 'Fashionable reading glasses, multiple colors', price: '49.99', image: 'https://images.unsplash.com/photo-1577803645773-f96470509666?w=800&auto=format' },
  { id: 5, title: 'Ellis Sports Eyewear', desc: 'Durable design for active lifestyles', price: '69.99', image: 'https://images.unsplash.com/photo-1591076482161-42ce6da69f67?w=800&auto=format' },
  { id: 6, title: 'Foster Frames', desc: 'Trendy oversized style, eco-friendly materials', price: '89.99', image: 'https://images.unsplash.com/photo-1574258495973-f010dfbb5371?w=800&auto=format' },
  { id: 7, title: 'Graham Polarized Shades', desc: 'Stylish beachwear with high UV protection', price: '119.99', image: 'https://images.unsplash.com/photo-1614715838608-dd527c46231d?w=800&auto=format' },
  { id: 8, title: 'Harrison Clip-Ons', desc: 'Versatile clip-on sunglasses for any occasion', price: '59.99', image: 'https://images.unsplash.com/photo-1473496169904-658ba7c44d8a?w=800&auto=format' },
];

export default function FeaturedProducts() {
  const { addToCart } = useCart();
  return (
    <section className="bg-white py-16 overflow-hidden">
      <div className="site-container">

        {/* Header Row */}
        <div data-aos="fade-up" className="mb-10 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 className="section-heading mb-2">
              Featured Products
            </h2>
            <p className="section-copy">
              Discover our handpicked collection of premium eyewear.
            </p>
          </div>
          <div className="pb-1">
            <Link to="/shop" className="text-brand-blue font-bold text-[16px] flex items-center gap-2 hover:underline">
              See More
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M9 18l6-6-6-6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Link>
          </div>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-x-8 lg:gap-y-10">
          {featuredProducts.map((product, index) => (
            <div 
              key={product.id} 
              data-aos="fade-up"
              data-aos-delay={index * 50}
              className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-[28px] border border-gray-100 bg-white shadow-sm transition-all duration-500 hover:shadow-2xl"
            >
              {/* Product Image */}
              <div className="relative aspect-[4/3] overflow-hidden bg-gray-50">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </div>

              {/* Product Info */}
              <div className="flex flex-grow flex-col p-5">
                <h3 className="mb-1 text-[17px] font-bold leading-tight text-brand-dark transition-colors group-hover:text-brand-blue sm:text-[18px]">
                  {product.title}
                </h3>
                <p className="text-gray-400 text-[13px] mb-5 leading-relaxed line-clamp-2">
                  {product.desc}
                </p>
                <div className="mt-auto flex items-center justify-between gap-2">
                  <p className="text-[18px] font-black text-brand-blue whitespace-nowrap">
                    <span className="text-[12px] font-bold mr-1">KSH.</span>
                    {product.price}
                  </p>
                  <button 
                    onClick={(e) => {
                      e.preventDefault();
                      addToCart(product);
                    }}
                    className="whitespace-nowrap rounded-xl bg-brand-red px-4 py-2 text-[13px] font-bold text-white shadow-md transition-all hover:bg-red-700 active:scale-95"
                  >
                    Add to Cart
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
